import React, { useContext, useState } from "react";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Context } from "@components/useContext/context";
import actions from "@actions/actionsMap";
import ArrowUp from "@public/images/arrow-up.svg";
import ArrowDown from "@public/images/arrow-down.svg";

const EXP = [
  {
    title: "Previous Policy Data",
    data: [
      {
        name: "Zero Depreciation - Super Saver",
        value: "₹22,620"
      },
      {
        name: "25% No Claim Bonus (NCB)",
        value: "-₹1,416"
      }
    ]
  },
  {
    title: "ADDONS",
    data: [
      {
        name: "Add-ons",
        value: "",
        isHeading: true
      },
      {
        name: "Passenger protection",
        value: "₹350"
      },
      {
        name: "Paid driver protection",
        value: "₹50"
      }
    ],
    showMinified: true
  },
  {
    title: "Premium Section",
    data: [
      {
        name: "Premium you paid",
        value: "₹21,604"
      }
    ]
  }
];
import {
  HeadingContainer,
  Heading,
  cardStyles,
  CardItem,
  CarDetailValue,
  CardContent,
  DisplayNameText,
  Dot,
  InfoTextContainer,
  // SeperatorLine,
  ExpandedDetailsContainer,
  MoreCoversTextContainer,
  AddonUpgradeTagContainer,
  StyledText,
  BulletMinifiedDetails,
  EditSection,
  FlexColContainer,
  CustomLiItem,
  LinkText,
  PremiumDetailsContainer,
  PremiumdetailWrapper,
  PremiumDetailHeading,
  PremiumDetailItem,
  PremiumDetailType,
  PremiumDetailValue,
  GrossPremiumText,
  GrossPremiumCueText,
  GrossPremiumAmount,
  HyperLinkText,
  CoverageDetailsText,
  LoadMore
} from "./styles";
import Card from "@components/Card";
import { useDispatch } from "react-redux";
import dynamic from "next/dynamic";
import {
  ADDONS_CONTAINER,
  capitalizeDisplayName,
  getJourneyType,
  IS_INFO_TEXT,
  MINIFIED_DETAILS,
  PREMIUM_DETAILS,
  sampleAnalytics
} from "@utils/index";
import EditIcon from "@public/images/icons/edit-icon.svg";
import ImageContainer from "@components/imageContainer";
import DOMPurify from "isomorphic-dompurify";
import { Divider, EditCta } from "@widgets/VehicleDetails/styles";
import CouponInput from "@components/CouponInput";
import Hyperlink from "@components/common/hyperlink";
import { PlanName } from "@components/planCard/styles";
import {
  convertToLakh,
  formatToINR,
  getShortAmountString
} from "@utils/inrFormatter";
import { isEmpty } from "@utils/lodash";
import actionsMap from "@actions/actionsMap";
import { resolvePath } from "@utils/resolvePath";

const InfoIcon: any =
  "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-review/car.svg";

const StarsIcon =
  "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-review/car.svg";

interface MinifiedDetail {
  value: string;
  type: string;
  styles?: {
    fontWeight?: number;
    color?: string;
  };
}

interface ExpandableListItem {
  key: string;
  type: string;
  value: string[] | string;
  keyStyles?: {
    fontWeight?: string;
  };
}

interface ExpandableDetails {
  type: string;
  value: ExpandableListItem[];
}

export interface ExpandableCard {
  id: string;
  text: string;
  style: Style;
  allowEdit: boolean;
  cardTitle: string;
  is_visible: boolean;
  headingIcon: string;
  showDetails: boolean;
  editDetailsIcon: string;
  editDetailsText: string;
  minifiedDetails?: MinifiedDetailsEntity[] | null;
  minifiedLinkText: string;
  editDetailsAction: EditDetailsAction;
  expandableDetails?: ExpandableDetailsEntity[] | null;
  expandableLinkText: string;
  showEditInHeader?: boolean;
}
export interface Style {}
export interface MinifiedDetailsEntity {
  IDV: string;
  type: string;
  value: string;
  addons: string;
  styles: Styles;
  plan_name: string;
}
export interface Styles {
  color?: null;
  fontWeight: number;
}
export interface EditDetailsAction {
  on_click?: OnClickEntity[] | null;
}
export interface OnClickEntity {
  args: Args;
  type: string;
}
export interface Args {
  requestBody: RequestBody;
}
export interface RequestBody {
  current_node: string;
  expected_node: string;
}
export interface ExpandableDetailsEntity {
  type: string;
  value?: ValueEntity[] | null;
}
export interface ValueEntity {
  key: string;
  type: string;
  value?: string | string[] | null;
  keyStyles?: KeyStyles | null;
}
export interface KeyStyles {
  fontWeight: string;
}

interface IExpandedDetailsData {
  name: string;
  value: any;
  emphasize?: boolean | undefined;
  showInfoIcon?: boolean | undefined;
  infoClickHandler?: Function;
  nameClickHandler?: Function;
  type?: string;
}

interface IExpandedDetails {
  // WARNING: DO NOT CHANGE THIS AS THIS IS MAPPED WITH NEW DATA RENDER LOGIC :-> 103 LINE
  title?: string;
  data: IExpandedDetailsData[];
  showMinified?: boolean;
  minifiedClickHandler?: Function;
}

const ExpandableCard = ({ ...props }: any) => {
  // console.log("hehe", props);
  const {
    cardTitle,
    editDetailsIcon,
    editDetailsText,
    expandableLinkText,
    headingIcon,
    minifiedLinkText,
    minifiedDetails,
    expandableDetails,
    allowEdit,
    showDetails,
    id,
    editDetailsAction,
    is_visible,
    showEditInHeader = false
  } = props;

  const { isDesktop } = useContext(Context);
  const [isTpJourney, setIsTpJourney] = useState<boolean>(false);
  const [showExpandedDetails, setShowExpandedDetails] = useState<boolean>(
    showDetails || false
  );
  const [shouldShowSeeMoreText, setShouldShowSeeMoreText] =
    useState<boolean>(true);

  const handleActionClick = (on_click) => {
    console.log("tp_redirection_fxn_outside", on_click);
    on_click?.forEach((act) => {
      const setterFxn = actionsMap?.[act?.type];
      console.log("tp_redirection_fxn", {
        name: setterFxn?.name,
        setter: setterFxn,
        act,
        isTpJourney
      });
      // if only tp journey there is no plan_selection_node, thus changing expectednode on runtime
      if (act?.type === "fetch_config_redirect" && isTpJourney) {
        console.log("tp_redirection_fxn_inside", act.args);
        let newArgs = {
          ...act.args,
          requestBody: { expected_node: "tp_only_plan_node" }
        };
        setterFxn(newArgs || {});
      } else if (act && typeof setterFxn === "function") {
        setterFxn(act?.args || {});
      }
    });
  };

  const getStyledtextJsx = (item) => {
    return (
      <StyledText
        styles={item?.styles}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.value) }}
      ></StyledText>
    );
  };
  const getBulletMinifiedDetailsJsx = (bulletMinifiedDetails) => {
    return (
      <Flex
        flexDirection="row"
        styles={{ alignItems: "center", gap: "0.5rem" }}
      >
        {bulletMinifiedDetails?.map((item, idx) => {
          // console.log("hehe", item);
          return (
            <>
              <StyledText styles={item?.styles}>
                {DOMPurify.sanitize(item?.value)}
              </StyledText>
              {idx < bulletMinifiedDetails?.length - 1 && <Dot />}
            </>
          );
        })}
      </Flex>
    );
  };

  const RenderUlItems = ({ items, type }) => {
    const [showFullList, setShowFullList] = useState(false);
    const dataToRender =
      getJourneyType() === "new_car" &&
      !showFullList &&
      type === "addonlistitem"
        ? items.slice(0, 3)
        : items;
    return (
      <div style={{ marginLeft: "8px",position: "relative" }}>
        {dataToRender?.map((item, index) => {
          return (
            <li key={index} style={type === "listitem" ? { listStyle: "none" } : {}}>
              <CustomLiItem className="custom-li-item" isSingleItem={type === "listitem"}>
                {type === "addonlistitem"
                  ? capitalizeDisplayName(item?.display_name)
                  : item}
              </CustomLiItem>
            </li>
          );
        })}
        {getJourneyType() === "new_car" &&
          !showFullList &&
          items.length > 3 &&
          type === "addonlistitem" && (
            <LoadMore
              className="custom-li-item"
              onClick={() => setShowFullList(true)}
            >
              +{items.length - 3} more
            </LoadMore>
          )}
      </div>
    );
  };

  const renderPremiumItem = (item) => {
    if (!item || item?.length === 0) return null;
    return item?.map((premiumItem) => {
      return (
        <PremiumDetailItem>
          <>
            <PremiumDetailType>{premiumItem?.key}</PremiumDetailType>
            <PremiumDetailValue isDiscount={premiumItem?.isDiscount}>
              {premiumItem?.isDiscount
                ? `- ₹${premiumItem?.value}`
                : `₹${premiumItem?.value}`}
            </PremiumDetailValue>
          </>
        </PremiumDetailItem>
      );
    });
  };

  const getPremiumDetailsJsx = (premiumDetailItem) => {
    if (!premiumDetailItem || isEmpty(premiumDetailItem?.data)) return null;
    return (
      <PremiumdetailWrapper>
        {premiumDetailItem?.heading && (
          <PremiumDetailHeading>
            {premiumDetailItem?.heading}
          </PremiumDetailHeading>
        )}
        {renderPremiumItem(premiumDetailItem?.data)}
      </PremiumdetailWrapper>
    );
  };

  const getGrossPremiumDetailsJsx = (grossPremiumItem) => {
    if (!grossPremiumItem?.data) return null;
    return (
      <PremiumdetailWrapper>
        {grossPremiumItem?.data?.map((item) => {
          return (
            <PremiumDetailItem>
              <Flex
                flexDirection="row"
                styles={{ alignItems: "baseline", gap: "4px", width: "50%" }}
              >
                <GrossPremiumText>{item?.key}</GrossPremiumText>
                <GrossPremiumCueText>{item?.cueText}</GrossPremiumCueText>
              </Flex>
              <GrossPremiumAmount>₹{item?.value}</GrossPremiumAmount>
            </PremiumDetailItem>
          );
        })}
      </PremiumdetailWrapper>
    );
  };

  const getFlexColDetailsJsx = (flexColDetailsItems) => {
    return flexColDetailsItems?.map((item) => {
      const { tpOnlyJourney = false } = item;
      if (tpOnlyJourney) {
        setIsTpJourney(true);
      }
      // todo: refactor this move this to another fxn :(
      if (typeof item?.value === "object" && isEmpty(item?.value)) {
        return null;
      }
      let content: any;
      switch (item?.type) {
        case "listitem":
          content = <RenderUlItems items={item?.value} type={item?.type} />;
          break;
        case "addonlistitem":
          content = <RenderUlItems items={item?.value} type={item?.type} />;
          break;
        case "idv":
          content = (
            <div
              style={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
                color: "#040222"
              }}
            >
              {formatToINR(item?.value, true)}
            </div>
          );
          break;
        default:
          content = (
            <Heading styles={item?.valueStyles} dwebStyles={item?.dwebValueStyles}>
              {DOMPurify.sanitize(item?.value)}
            </Heading>
          );
      }
      return (
        <Flex flexDirection="column" styles={{ gap: "0.25rem" }}>
          <StyledText styles={item?.keyStyles}>
            {DOMPurify.sanitize(item?.key)}
          </StyledText>
          {content}
        </Flex>
      );
    });
  };

  const getFormattedAddonsText = (addons) => {
    if (!addons || addons?.length === 0) return "";
    return `with ${addons?.length} more additional cover${addons?.length > 1 ? "s" : ""}`;
  };

  const getFormattedCoverageDetails = (item) => {
    const { plan_name, IDV, addons, tpOnlyJourney = false } = item;
    if (tpOnlyJourney) {
      setIsTpJourney(true);
    }
    const formattedIdv = IDV ? `(₹${convertToLakh(IDV)} lakh IDV)` : ``;
    const formattedAddonsText = addons ? getFormattedAddonsText(addons) : "";
    return (
      <CoverageDetailsText>
        {plan_name} {formattedIdv} {formattedAddonsText}
      </CoverageDetailsText>
    );
  };

  const GetJsxForType = ({ type, item }) => {
    switch (type) {
      case "text":
        return getStyledtextJsx(item);
      case "bulletMinifiedDetails":
        return (
          <BulletMinifiedDetails>
            {getBulletMinifiedDetailsJsx(item?.value)}
          </BulletMinifiedDetails>
        );
      case "flexColDetails":
        return (
          <FlexColContainer>
            {getFlexColDetailsJsx(item?.value)}
          </FlexColContainer>
        );
      case "coverage_details":
        const displayValue = getFormattedCoverageDetails(item);
        return <div>{displayValue}</div>;
      case "linktext":
        return <>div</>;
      case PREMIUM_DETAILS:
        if (isEmpty(item?.data)) return <></>;
        return (
          <PremiumDetailsContainer>
            {getPremiumDetailsJsx(item)}
          </PremiumDetailsContainer>
        );
      case "GROSS_PREMIUM":
        return (
          <PremiumDetailsContainer>
            {getGrossPremiumDetailsJsx(item)}
          </PremiumDetailsContainer>
        );
      case "coupon_input":
        return <CouponInput {...item} />;
      case "hyperlink_text":
        // console.log("xoxo", item);
        return item?.is_visible ? (
          <HyperLinkText
            onClick={() => handleActionClick(item?.actions?.on_click)}
          >
            {item?.value}
          </HyperLinkText>
        ) : null;

      default:
        return <></>;
    }
  };

  const RenderMinifiedDetails = ({ minifiedDetails }) => {
    return minifiedDetails?.map((detailItem) => {
      return <GetJsxForType type={detailItem?.type} item={detailItem} />;
    });
  };

  const RenderExpandedDetails = ({ expandableDetails }) => {
    if (!expandableDetails) return null;
    return expandableDetails?.map((detailItem) => {
      return <GetJsxForType type={detailItem?.type} item={detailItem} />;
    });
  };

  // TODO: USE 'implements' FOR THIS COMPARISON
  const instanceOfIExpandedDetails = (object: any) => {
    console.log("sample", object);
    return false;
    return "title" in object?.[0] && "data" in object?.[0];
  };

  const getFormattedData = (data): IExpandedDetails[] => {
    // check if new data format then don't format data
    if (instanceOfIExpandedDetails(data)) {
      return data;
    }
    // else format data to new format IExpandedDetails
    return [{ title: "", data }];
  };

  const dataToRender = getFormattedData(expandableDetails);

  const DetailItem = ({ detail }) => {
    return (
      <>
        <Flex key={detail?.name} justifyContent="space-between">
          <CardItem isDesktop={isDesktop} styles={{ maxWidth: "max-content" }}>
            {detail?.type === IS_INFO_TEXT ? (
              <InfoTextContainer onClick={detail?.nameClickHandler}>
                {detail?.name}
              </InfoTextContainer>
            ) : (
              <DisplayNameText
                emphasize={detail?.emphasize}
                isHeading={detail?.isHeading}
              >
                {detail?.name}
                {detail?.showInfoIcon && (
                  <ImageContainer
                    imgSrc={InfoIcon}
                    onClick={() => {
                      detail?.infoClickHandler?.();
                    }}
                  />
                )}
              </DisplayNameText>
            )}
          </CardItem>
          {detail?.value && (
            <CardItem isDesktop={isDesktop} justifyContent="flex-end">
              <CarDetailValue
                isEdit={detail?.isEdit}
                onClick={detail?.editClickHandler}
              >
                {detail?.value}
              </CarDetailValue>
            </CardItem>
          )}
        </Flex>
        {detail?.isUpgradeAvailable && (
          <AddonUpgradeTagContainer
            onClick={() => {
              detail?.upgradeClickHandler && detail?.upgradeClickHandler();
            }}
          >
            {/* <StyledRightArrow /> */}
          </AddonUpgradeTagContainer>
        )}
      </>
    );
  };

  const RenderDataItem = ({ dataItem }) => {
    const isAddonsContainer =
      dataItem?.showMinified &&
      dataItem?.title === ADDONS_CONTAINER &&
      dataItem?.data?.length > 3;

    let renderedMoreCovers = false;

    return (
      <Flex flexDirection="column" style={{ gap: "1rem", marginTop: "1rem" }}>
        {dataItem?.data?.map((data, index) => {
          if (isAddonsContainer && index > 2) {
            if (!renderedMoreCovers) {
              renderedMoreCovers = true;
              return (
                <MoreCoversTextContainer
                  onClick={dataItem?.minifiedClickHandler}
                  key="more-covers"
                >
                  {`+${dataItem?.data?.length - 3} more covers`}
                </MoreCoversTextContainer>
              );
            } else {
              return null;
            }
          }

          if (data?.value || data?.type === IS_INFO_TEXT || dataItem?.title) {
            return <DetailItem detail={data} key={index} />;
          } else {
            return null;
          }
        })}
      </Flex>
    );
  };

  return (
    <>
      {is_visible ? (
        <>
          <Card
            styles={cardStyles({
              show: showDetails,
              styles: showDetails
                ? ""
                : "background-color: white; border: 1px solid #E7E7F0;"
            })}
            id={id}
          >
            <>
              <HeadingContainer
                onClick={(e) => {
                  e.stopPropagation();
                }}
                isDesktop={isDesktop}
                id="kaa"
              >
                <Flex
                  alignItems="center"
                  styles={{
                    boxSizing: "border-box",
                    gap: "8px",
                    width: "auto"
                  }}
                >
                  {/* todo: change hardcoded true  */}
                  {true && (
                    <div style={{ width: "24px", height: "24px" }}>
                      <ImageContainer
                        imgSrc={
                          // todo: get icon from backend url
                          headingIcon
                        }
                        style={{
                          marginRight: "0.5rem",
                          objectFit: "contain"
                        }}
                      />
                    </div>
                  )}
                  <Heading>{cardTitle} </Heading>
                </Flex>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    boxSizing: "border-box"
                  }}
                >
                  {showEditInHeader ? (
                    <EditSection
                      onClick={() =>
                        handleActionClick(editDetailsAction?.on_click)
                      }
                      style={{ padding: "0px" }}
                    >
                      <ImageContainer
                        imgSrc={editDetailsIcon}
                        height={20}
                        width={20}
                      />{" "}
                    </EditSection>
                  ) : (
                    shouldShowSeeMoreText &&
                    minifiedLinkText && (
                      <LinkText
                        onClick={() => {
                          setShowExpandedDetails((val) => !val);
                          sampleAnalytics(
                            "action",
                            "tap_btn",
                            "tap_btn_see_more_coverage_details"
                          );
                        }}
                      >
                        {showExpandedDetails ? <ArrowUp /> : <ArrowDown />}
                      </LinkText>
                    )
                  )}
                </div>
              </HeadingContainer>
              <div
                style={{
                  transition: "max-height 0.3s cubic-bezier(0.4, 0, 1, 1) 0s",
                  maxHeight: showExpandedDetails ? "1000px" : "200px",
                  overflow: "hidden"
                }}
              >
                <CardContent isDesktop={isDesktop}>
                  {showExpandedDetails ? (
                    <>
                      <RenderExpandedDetails
                        expandableDetails={expandableDetails}
                      />
                    </>
                  ) : (
                    <>
                      <Flex flexDirection="column">
                        <RenderMinifiedDetails
                          minifiedDetails={minifiedDetails}
                        />
                      </Flex>
                    </>
                  )}
                </CardContent>
                {showExpandedDetails && allowEdit && !showEditInHeader && (
                  // todo: add  redirection to the user-edits page
                  <EditSection>
                    <ImageContainer
                      imgSrc={editDetailsIcon}
                      height={20}
                      width={20}
                    />{" "}
                    <EditCta
                      onClick={() =>
                        handleActionClick(editDetailsAction?.on_click)
                      }
                    >
                      {editDetailsText}
                    </EditCta>
                  </EditSection>
                )}
              </div>
            </>
          </Card>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ExpandableCard;
